package com.catbit.opinionpoll.core.sailor.providers

import androidx.compose.runtime.staticCompositionLocalOf
import com.catbit.opinionpoll.core.sailor.overlays.snackbar.SnackBarState

val LocalSnackbarState = staticCompositionLocalOf<SnackBarState> {
    error("SnackbarState was not provided")
}